// TODO: config file
const LAST_PAGE_LOCALSTORAGE_KEY = "last-page";
const LAST_STATE_LOCALSTORAGE_KEY = "last-state";

export function saveStateAndPage(page: string, state: any) {
    localStorage.setItem(LAST_PAGE_LOCALSTORAGE_KEY, page);
    localStorage.setItem(LAST_STATE_LOCALSTORAGE_KEY, JSON.stringify(state));
    history.replaceState(state, "", page);
}
